<nb-card class="card-box" id="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="play-circle-outline" status="basic"></nb-icon>
        <span class="title">{{'common.print-file' | translate}}</span>
        <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control" class="mr-2 cursor-help"
            nbTooltip="{{'tooltips.print-file-from-device' | translate}}" nbTooltipPlacement="left"></nb-icon>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>

    <nb-card-body *ngIf="!confirmationDialogIsActive" class="content-body"
        [nbSpinner]="transferResources === undefined">
        <ng-container *ngIf="transferResources">
            <div class="devices-slots-included-in-plan-box"
                [ngClass]="{'devices-slots-included-in-plan-box__border-bottom' : transferResources.totalTransfer - transferResources.currentTransfer > 0 && device.status && device.status.memory && device.status.memory.total !== 0}">
                <app-add-more-resources-card [resource]="resourceTypes['transfer']"
                    [currentCount]="transferResources.currentTransfer"
                    [priceForOneUnit]="transferResources.priceForOneUnit" [totalCount]="transferResources.totalTransfer"
                    [totalLimit]="transferResources.totalTransferLimit" [currency]="transferResources.currency"
                    title="{{(transferResources.totalTransfer - transferResources.currentTransfer > 0 ? 'stats-and-resources.transfer':'stats-and-resources.no-transfer-available') | translate}}"
                    description="{{'stats-and-resources.transfer-in-your-plan' | translate}}
                                          ({{'stats-and-resources.used' | translate}} GB/{{'stats-and-resources.total' | translate}} GB).
                                          {{(transferResources.totalTransfer - transferResources.currentTransfer > 0 ? '':'stats-and-resources.you-must-purchase-transfer') | translate}}"
                    button="{{(transferResources.totalTransfer - transferResources.currentTransfer > 0 ? '' : 'stats-and-resources.add-more-transfer')}}"
                    [doughnutHeight]="110" [doughnutWidth]="110" [isActive]="transferResources.isActive"
                    (clickedAddMoreResources)='onClickAddMoreResources()'>
                </app-add-more-resources-card>
            </div>

            <app-upload-file-to-server #uploadFile (fileUploaded)='onFileUploaded($event.data)'
                [methodName]="uploadMethod" [deviceData]="deviceUploadData"
                [extensions]="allowedFileExtensions"
                [disabled]="!directPrintEnabled && uploadToDeviceDisabled">
            </app-upload-file-to-server>
        </ng-container>

        <div *ngIf="device" class="select-file-box">
            <div class="title-box">
                {{'device.files.select-file' | translate}}
            </div>
            <div class="device-card-box">
                <div class="image-box">
                    <img [src]="'assets/device/'+ device.picture" class="image-box--image" alt="roboze-photo">
                </div>
                <div class="base-information-box">
                    <div class="base-information-box__name">
                        {{ device.name }}
                    </div>
                    <div class="base-information-box__type">
                        {{ device | serialNumberWithDeviceType }}
                    </div>
                    <div class="base-information-box__loaded-material"
                        *ngFor="let material of device.status.currentLoadedMaterials; trackBy: trackByFn">
                        {{'device.status.loaded-material' | translate}}: <span
                            class="font-weight-bold">{{material.name}}</span>
                    </div>
                </div>
            </div>

            <app-file-browser
                *ngIf="files"
                (onLoadNewPage)="onNext()"
                (onLoadDirectory)="changeCatalog($event?.path || '')"
                (onPrint)="showConfirmation($event)"
                [(sort)]="sortType"
                [enablePrint]="true"
                [compactMode]="true"
                [rootPath]="device.name"
                [displayType]="displayType"
                [isLoading]="loadingFiles"
                [files]="files.data | sortBy: sortType.direction : sortType.field">
                <ng-template #infoTemplate let-file>
                    <div class="box__file__info">
                        <div>
                            {{ 'common.created-at' | translate }}:
                            <span class="fw-bold">{{file.date | date : "dd.MM.yyy"}}</span>
                        </div>
                        <div *ngIf="file.printTime > 0">
                            {{'device.files.printing-time' | translate}}:
                            <span class="fw-bold">
                                <ng-template [ngIf]="(file.printTime | secondsToDays) >=1">{{file.printTime | secondsToDays}}d</ng-template>
                                {{file.printTime * 1000 | date:'HH:mm:ss':'UTC'}}
                            </span>
                        </div>
                        <div *ngIf="file.materials.length > 0">
                            {{'device.files.material' | translate}}:
                            <span *ngFor="let material of file.materials; trackBy: trackByFn" class="fw-bold">
                                {{material.name}} ({{material.used}}{{material.unit}})
                                <span *ngIf="material !== file.materials[file.materials.length - 1]">,</span>
                            </span>
                        </div>
                    </div>
                </ng-template>
            </app-file-browser>

            <div class="file-box--empty" *ngIf="!files && device?.status?.memory?.total === 0">
                {{'device.files.no-memory' | translate}}
            </div>
            
            <div class="button-cancel-box">
                <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'"
                    class="appearance-outline" (click)="cancel()">
                    {{'common.cancel' | translate}}
                </button>
            </div>
        </div>
    </nb-card-body>
</nb-card>